// Wired directly to the external "thinkable" Supabase project.
// NOTE: This project intentionally bypasses Lovable Cloud. Do not let
// auto-generation overwrite these values — they must point at thinkable.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = 'https://fifmqocfbnsudpxqrfxj.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_Xq-faieMDPY9LwVL5-nX9g_FuFxoEyI';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
